import { render, staticRenderFns } from "./CaxtonNav.vue?vue&type=template&id=78f4721e&scoped=true&"
import script from "./CaxtonNav.vue?vue&type=script&lang=js&"
export * from "./CaxtonNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4721e",
  null
  
)

export default component.exports